import { render, staticRenderFns } from "./LesionesCard.vue?vue&type=template&id=e7fd6f58"
import script from "./LesionesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LesionesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports